import { Component } from '@theme/component';

/**
 * @typedef {object} DropAHintRefs
 * @property {HTMLElement} [status] - Polite status for the copy fallback.
 */

/**
 * Shares a gift hint with the native share sheet; the link's mailto: href stays the no-JS and
 * no-share-API fallback.
 *
 * @extends Component<DropAHintRefs>
 */
class DropAHint extends Component {
  /** @param {MouseEvent} event */
  async share(event) {
    const { title = '', text = '', url = '' } = this.dataset;
    if (typeof navigator.share !== 'function') return; // let the mailto: link open

    event.preventDefault();
    try {
      await navigator.share({ title, text, url });
    } catch (error) {
      if (error instanceof Error && error.name === 'AbortError') return;
      try {
        await navigator.clipboard.writeText(`${text} ${url}`);
        if (this.refs.status) this.refs.status.textContent = this.dataset.copied ?? '';
      } catch {
        // Nothing else to try; the shopper can still use the mailto: link.
      }
    }
  }
}

if (!customElements.get('drop-a-hint-component')) {
  customElements.define('drop-a-hint-component', DropAHint);
}
